import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContactMethods from './components/ContactMethods';
import BookingCTA from './components/BookingCTA';

const ContactPage = () => {
  useEffect(() => {
    document.title = 'Contact & Book Appointment | Riverdale Hair Studio Otley';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Book your appointment at Riverdale Hair Studio in Otley. Call us, email, or visit our salon for expert hair services. Walk-ins welcome. Open Mon-Sat, 9am-6pm.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ContactMethods />
        <BookingCTA />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;